import { render } from "./myteam.vue?vue&type=template&id=08c324b2&scoped=true"
import script from "./myteam.vue?vue&type=script&lang=js"
export * from "./myteam.vue?vue&type=script&lang=js"

import "./myteam.vue?vue&type=style&index=0&id=08c324b2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c324b2"]])

export default __exports__